import { render, staticRenderFns } from "./chevron_right.vue?vue&type=template&id=174224db&scoped=true&"
import script from "./chevron_right.vue?vue&type=script&lang=js&"
export * from "./chevron_right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174224db",
  null
  
)

export default component.exports